import { Box, Stack, TextField, Button, Tooltip, Typography, FormControlLabel, Checkbox } from '@mui/material'
import { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'

const TreatmentTechnique = ({Access}) => {
    const [state, setState] = useState({
        treatment_technique_master_data: [],
        therapy_technique_name: '',
        therapy_technique_code: null,
        is_active: true,
        edit_id: null,
        is_loader: false,
        deleted_ids: [],
        is_delete: false,
        checkbox_list: [],
        page: 0,
        pageSize: 10,
        //toast msg state
        isErrorMsg: false,
        isErrorMsgText: '',
        successMsg: false,
        successMsgText: "",
    });

    useEffect(() => {
        getTreatmentTechniqueMasterList()
    }, [])

    const updateState = (updates) => {
        setState((prev) => ({ ...prev, ...updates }));
    };

    const successMessage = (message) => {
        updateState({
            successMsg: true,
            successMsgText: message
        })
    }

    const errorMessage = (message) => {
        updateState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    const msgClose = () => {
        updateState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ""
        })
    }

    const getTreatmentTechniqueMasterList = () => {
        try {
            updateState({ is_loader: true })
            RestAPIService.getAll(Serviceurls.TREATMENT_TECHNIQUE_GET)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const Data = response.data.data || []
                        updateState({
                            treatment_technique_master_data: Data?.map((element, index) => ({ ...element, sno: index + 1 })),
                            is_loader: false
                        })
                    }
                }).catch(e => {
                    updateState({ is_loader: false })
                    errorMessage(e?.response?.data?.message || e?.message)
                })
        } catch (e) {
            updateState({ is_loader: false })
            errorMessage(e.message)
        }
    }

    const textBox = (label, name, width, disable = false) => {
        return (
            <Box>
                <TextField
                    size='small'
                    name={name}
                    disabled={disable}
                    inputProps={{ maxLength: 250 }}
                    value={state[name] || ""}
                    sx={{ width: width, marginRight: '0.3vw' }}
                    label={label}
                    onChange={(e) => { updateState({ [name]: e.target.value }) }}
                    variant="outlined"
                />
            </Box>
        )
    }

    const tableView = () => {

        const grpDelete = () => {
            updateState({ is_delete: true })
        }

        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText fromStore={true} isDelete={state?.deleted_ids?.length > 0} removeData={grpDelete.bind(this)}  DeleteBtnText={"Inactive"}/>
                </Box>
            )
        }

        const handleTableCheckbox = (id) => {
            const selectedIDs = new Set(id);
            const selectedRows = state?.treatment_technique_master_data?.filter((row) => selectedIDs.has(row.sno));
            const FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item.id)
            })
            updateState({ checkbox_list: id, deleted_ids: FinalData })
        }

        const columns = [
            {
                field: 'therapy_technique_code', headerName: 'Code', flex: 0.2,
                renderCell: ({ row }) => (<Box component={'div'}>{row?.therapy_technique_code ? row?.therapy_technique_code : '-'}</Box>)

            },
            {
                field: 'therapy_technique_name', headerName: 'Therapy Technique', flex: 0.5,
                renderCell: ({ row }) => (row.therapy_technique_name ? row.therapy_technique_name?.length > 50 ?
                    <Tooltip placement="top" title={row.therapy_technique_name}><Typography fontSize={'0.9vw'}>{row.therapy_technique_name?.slice(0, 50) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{row.therapy_technique_name}</Typography> : '-')

            },
            {
                field: 'is_active', headerName: 'Status', flex: 0.2,
                renderCell: ({ row }) => (<Box component={'div'}>{row?.is_active ? "Active" : 'InActive'}</Box>)
            },
            {
                field: 'action', headerName: 'Action', flex: 0.1,
                renderCell: ({ row }) => (
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                            <CommonEditButton size="1.5vw"
                                disable={state?.deleted_ids?.length > 0 || !Access?.editAccess}
                                onClick={() => {
                                    updateState({
                                        therapy_technique_name: row.therapy_technique_name || "",
                                        therapy_technique_code: row.therapy_technique_code || "",
                                        is_active: row.is_active,
                                        edit_id: row.id
                                    })
                                }} />
                        </Stack>
                    </Stack>)

            },
        ]
        return (
            <Box sx={{ height: '61vh', marginTop: '.5vw' }}>
                <DataGrid
                    checkboxSelection={Access?.editAccess}
                    selectionModel={state.checkbox_list}
                    onSelectionModelChange={(id) => handleTableCheckbox(id)}
                    isRowSelectable={(params) => params.row.is_active}
                    rows={state.treatment_technique_master_data}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={state.page}
                    pageSize={state.pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    hideFooter
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { updateState({ page: newPage }) }}
                    onPageSizeChange={(newPageSize) => { updateState({ pageSize: newPageSize }) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    loading={state.is_loader}
                />
            </Box>
        )
    }

    const clearFunction = () => {
        updateState({
            therapy_technique_name: '',
            therapy_technique_code: null,
            is_active: true,
            edit_id: null,
            is_loader: false,
            deleted_ids: [],
            checkbox_list: [],
            is_delete: false,
        })
    }

    const addTreatmentTechniqueDetails = () => {
        try {
            const data = {
                'technique_name': state.therapy_technique_name,
                'is_active': state.is_active,
            }
            if (state?.edit_id) {
                data["id"] = state?.edit_id
            }
            RestAPIService[state.edit_id ? "updateWithOutId" : "create"](data, Serviceurls.TREATMENT_TECHNIQUE_GET)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        clearFunction()
                        getTreatmentTechniqueMasterList()
                    }
                }).catch(e => {
                    updateState({ is_loader: false })
                    errorMessage(e?.response?.data?.message || e?.message)
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const deleteTreatmentTechniqueMaster = () => {
        try {
            RestAPIService.delete(`${Serviceurls.TREATMENT_TECHNIQUE_GET}?ids=${state.deleted_ids || []}`, {})
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        getTreatmentTechniqueMasterList()
                        clearFunction()
                    }
                }).catch(e => {
                    errorMessage(e?.response?.data?.message || e?.message)
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const deleteClsPop = () => {
        updateState({
            is_delete: false,
            checkbox_list: [],
            deleted_ids: [],
        })
    }

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} sx={{ height: '15.5vh', width: '93vw', backgroundColor: 'white', padding: '.6vw', }}>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', }}>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', }}>
                        {textBox("Therapy Technique Code", 'therapy_technique_code', '15vw', true)}
                        {textBox("Therapy Technique *", 'therapy_technique_name', '30vw')}
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', marginTop: '1vw', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex' }}>
                        <FormControlLabel control={
                            <Checkbox checked={state.is_active}
                                onChange={(e) => { updateState({ is_active: e.target.checked }) }}
                                size='small' disabled={!state.edit_id} />}
                            label={"Active"} />
                    </Box>
                    <Box sx={{ gap: '1vw' }}>
                        <Button size='small' variant='outlined' sx={{ textTransform: 'capitalize', width: '7vw' }} onClick={() => { clearFunction() }}>Clear</Button>
                        <Button size='small' variant='contained' sx={{ textTransform: 'capitalize', width: '7vw', marginLeft: '1vw' }} disabled={!state.therapy_technique_name || !Access?.editAccess} onClick={() => { addTreatmentTechniqueDetails() }}>{state.edit_id ? "Update" : "Add"}</Button>
                    </Box>
                </Box>
            </Box>
            <Box component={'div'} sx={{ height: '61vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white', }}>
                {tableView()}
            </Box>
            {state.isErrorMsg && <ToastMsg severity={"error"} msg={state.isErrorMsgText} msgPop={msgClose.bind(this)} />}
            {state.successMsg && <ToastMsg severity={"success"} msg={state.successMsgText} msgPop={msgClose.bind(this)} />}
            {state.is_delete &&
                <DeletePopup
                    DeletTitle={`Are you sure, Do you want to InActive this technique ?`}
                    deleteAlertPopupClose={deleteClsPop.bind(this)}
                    removeData={deleteTreatmentTechniqueMaster.bind(this)}
                    ButtonText={"Inactive"}
                />}
        </Box>
    )
}
export default TreatmentTechnique